import React from "react";
import S from './Archive.module.scss';
import {Carousel} from "@mantine/carousel";
import {archive} from "../../shared/mock/partners";
import {Image} from "@mantine/core";
import {useNavigate} from "react-router-dom";

export const Archive = () => {
    const navigate = useNavigate();
    return (
        <div className={S.archive} id="archive">
            <div className={S.archiveContainer}>
                <div>
                    <h1 className={S.title}>Как это было</h1>
                    <div className={S.text}>Архив прошедших мероприятий с фотоотчетами</div>
                </div>
                <Carousel
                    classNames={{controls: S.controls, root: S.carouselRoot}}
                    className={S.containerCards}
                    slideSize={{ base: '100%', sm: '70%', md: '45%' }}
                    slideGap={{ base: 'lg', lg: '40px', md: '40px' }}
                    emblaOptions={{ loop: true, align: 'start' }}
                    withControls={archive.length > 2}
                    controlsOffset="md"
                >
                    {archive.map((item: any) => (
                        <Carousel.Slide key={item.id}>
                            <div className={S.card} onClick={() => navigate(`/event/${item.titleUrl}`)}>
                                <div className={S.cardImage}>
                                    <Image
                                        src={item.images}
                                        alt={item.title}
                                        fit="contain"
                                    />
                                    <div className={S.numberPhotos}>{item.numberPhotos}</div>
                                </div>
                                <div className={S.cardInfo}>
                                    <div>
                                        <div className={S.titleInfo}>{item.title}</div>
                                        <div className={S.descriptionInfo}>{item.description}</div>
                                    </div>
                                    <div className={S.cardText}>
                                        <div>{item.date}</div>
                                        ·
                                        <div>{item.location}</div>
                                    </div>
                                </div>
                            </div>
                        </Carousel.Slide>
                    ))}
                </Carousel>
            </div>
        </div>
    );
};